const general = {
  black: '#000000',
  white: '#fff',
  grey: '#3D3D3D',
  lightGrey: '#d3d3d3'
}

export default general
